import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children", "id", "copyLink"];

var _IconInsertLink;

import React, { forwardRef, useState } from 'react';
import Heading from '../Heading';
import IconButton from '../IconButton';
import IconInsertLink from '../IconInsertLink';
var Anchor = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var to = _ref.to;
  return /*#__PURE__*/React.createElement(IconButton, {
    as: "a",
    ref: ref,
    href: to,
    size: 22,
    sx: {
      m: 0,
      p: 0,
      ml: 2,
      verticalAlign: 'middle',
      cursor: 'pointer'
    }
  }, _IconInsertLink || (_IconInsertLink = /*#__PURE__*/React.createElement(IconInsertLink, {
    size: 22
  })));
});
Anchor.displayName = 'Anchor';

var getLink = function getLink(href) {
  if (typeof window === 'undefined') {
    return '';
  }

  var _document$location = document.location,
      origin = _document$location.origin,
      search = _document$location.search,
      pathname = _document$location.pathname;
  return "".concat(origin + pathname + search, "#").concat(href);
};

var HeadingAnchor = /*#__PURE__*/forwardRef(function (_ref2, ref) {
  var children = _ref2.children,
      id = _ref2.id,
      copyLink = _ref2.copyLink,
      rest = _objectWithoutProperties(_ref2, _excluded);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      inHover = _useState2[0],
      setHover = _useState2[1];

  var to = copyLink || getLink(id);
  return /*#__PURE__*/React.createElement(Heading, _extends({
    onMouseEnter: function onMouseEnter() {
      return setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setHover(false);
    },
    id: id,
    ref: ref
  }, rest), children, (id || copyLink) && inHover && /*#__PURE__*/React.createElement(Anchor, {
    to: to
  }));
});
HeadingAnchor.displayName = 'HeadingAnchor';
process.env.NODE_ENV !== "production" ? void 0 : void 0;
export default HeadingAnchor;